import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Table, Tooltip } from "antd";

import Content from "../../commons/components/content";
import SearchInput from "../../commons/components/searchInput";
import ButtonIcon from "../../commons/components/buttonIcon";

import Utils from "../../commons/utils/utils"

import Http from "../../commons/utils/Http";

export default () => {

    const [tableData, setTableData] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [sorter, setSorter] = useState({ field: "creation_date", order: "descend" });
    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({});
    const [filterApplications, setFilterApplications] = useState([{}]);   
    const filterStatus = [{ text: 'pendente', value: 'pendente' }, { text: 'resolvido', value: 'resolvido' }]; 

    const tableColumns = [
        {
            title: 'Nome',
            dataIndex: 'user_name',
            key: 'user_name',
            sorter: true,
            width: '20%',
            ellipsis: true,
        },
        {
            title: 'E-mail',
            dataIndex: 'email',
            key: 'email',
            sorter: true,
            width: '20%',
            ellipsis: true,
        },
        {
            title: 'Aplicação',
            dataIndex: 'name',
            key: 'application_id',
            filters: filterApplications,
            ellipsis: true,
        },
        {
            title: 'Data',
            dataIndex: 'creation_date',
            key: 'creation_date',
            sorter: true,
            defaultSortOrder: 'descend',
            ellipsis: true,
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
            render: description => (
                <Tooltip placement="topLeft" title={description}>
                    {description}
                </Tooltip>
            ),
            ellipsis: true,
        },
        {
            title: 'Avaliação',
            dataIndex: 'evaluate',
            key: 'evaluate',
            sorter: true,
            ellipsis: true,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: filterStatus,
            filterMultiple: false,
            ellipsis: true,
        },
        {
            title: 'Ação',
            key: 'action',
            align: "center",
            render: (text, feedback) => (
                <div style={{ display: 'flex' , display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ButtonIcon className="button-blue" text="Atualizar status do Feedback" type="book" callback={() => update(feedback)} />
                </div>
            ),
            ellipsis: true,
        },
    ];

    useEffect(() => {
        getFilterApplications();
    }, []);

    useEffect(() => {
        getFeedbacksOrSearch(pagination, filters, sorter, search)  
    }, [search]);

    function formatTable(data) {
        let array = [];
        data.forEach((feedback) => {
            feedback.key = feedback.id;
            feedback.creation_date = Utils.formatDate(feedback.creation_date);
            array.push(feedback)
        })
        setTableData(array);
    }

    function handleSearch(e) {
        setSearch(e.target.value);        
    }

    function isFiltered(filters) {
        let result = false;
        Object.keys(filters).forEach((key) => {
            if(Object.values(filters[key]).length > 0){
                result = true;
            }
        });
        return result;
    }

    function getFeedbacksOrSearch(pagination, filters, sorter, search) {                   
        let filtered = isFiltered(filters);      
        if (search === "" && !filtered) {
            getFeedbacks(pagination, sorter);
        } else {
            searchFeedback(pagination, filters, sorter, search)
        }
    }

    function getFeedbacks(pagination, sorter) {
        const order = getOrder(sorter);
        const offset = pagination.current;

        setTableLoading(true);        
        Http.get(`/feedbacks/get-all?offset=${offset}&order=${order}`, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    formatTable(response.data.data)                    
                    setPagination({...pagination, total: response.data.pagination});

                    setTableLoading(false);
                }
            }).catch(err => {
                setTableLoading(false);
            })
    }

    function searchFeedback(pagination, filters, sorter, search) {
        const body = {
            "order": getOrder(sorter),
            "offset": pagination.current,
            "search": search,
            "filters": filters
        };

        setTableLoading(true);
        Http.post(`/feedbacks/search`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    formatTable(responseData.data)
                    setTableLoading(false);
                    setPagination({current: 1, pageSize: 10, total: response.data.pagination});
                }
            }).catch(err => {
                setTableData([]);
                setTableLoading(false);
            })
    }

    function getFilterApplications() {
        setTableLoading(true);
        Http.get(`/applications/get-all?offset=${0}&order=${"name"}`, Http.headers)
            .then(response => {
                const responseData = response.data.response;
                const data = response.data.data;
                if (!responseData.error) {
                    setTableLoading(false);
                    let array = [];
                    data.map(app => {
                        array.push({
                            "text": app.name,
                            "value": app.id
                        })
                    });
                    array = array.filter(function (a) {
                        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                    }, Object.create(null))
                    setFilterApplications(array);
                }
            }).catch(err => {
                setTableLoading(false);
            })
    }

    function update(data) {
        let status = "";
        if (data.status == "pendente") {
            status = "resolvido";
        } else {
            status = "pendente";
        }
        const body = { "id": data.id, "status": status }
        Http.put(`/feedbacks`, body, Http.headers)
            .then(response => {
                const responseData = response.data.response
                if (!responseData.error) {
                    getFeedbacksOrSearch(pagination, filters, sorter, search)  
                }
            }).catch(err => {
                setTableLoading(false);
            })
    }

    const renderSearchFeedback = () => (
        <div style={{ marginBottom: 10 }}>
            <SearchInput
                placeholder="Pesquisar..."
                onChange={handleSearch}
                value={search}
                buttonLabel="Limpar" type="close" callback={() => setSearch("")} />
        </div>
    );

    function getOrder(sorter){
        switch (sorter.order) {
            case 'ascend':
                return sorter.field + ' asc'
            case 'descend':
                return sorter.field + ' desc'
            default:
                return sorter.field
        }
    }

    function handleOnChangeTable(pagination, filters, sorter, currentPageData){  

        Object.keys(filters).forEach((key) => {
            if(!filters[key]){
                delete filters[key]
            }
        });

        setSorter(sorter);
        setFilters(filters);
        getFeedbacksOrSearch(pagination, filters, sorter, search);
    }

    const renderTable = () => (
        <Fragment>
            <Col span={24}>
                <div style={{ marginBottom: 20 }}>
                    <Table                        
                        columns={tableColumns}
                        rowKey={record => record.id}
                        dataSource={tableData}
                        pagination={pagination}                        
                        loading={tableLoading}
                        onChange={handleOnChangeTable}
                        locale={{ emptyText: 'Sem dados' }}
                    />
                </div>
            </Col>
        </Fragment>
    );

    const renderHeader = () => (
        <Fragment>
            <Col span={8}>
                {renderSearchFeedback()}
            </Col>
        </Fragment>
    );

    return (
        <>
            <Content breadcrumb={["Feedbacks"]} minHeight={360}>
                <Row type="flex" align="middle">
                    {renderHeader()}
                </Row>

                <Row>
                    {renderTable()}
                </Row>
            </Content>
        </>
    )
}